import { render, staticRenderFns } from "./WelcomeInvitationDialog.vue?vue&type=template&id=ae5bd05c&scoped=true"
import script from "./WelcomeInvitationDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeInvitationDialog.vue?vue&type=script&lang=js"
import style0 from "./WelcomeInvitationDialog.vue?vue&type=style&index=0&id=ae5bd05c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5bd05c",
  null
  
)

export default component.exports